//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultLayout from '~/layouts/default.vue';
import PrimaryHeader from '~/components/headers/PrimaryHeader';

export default {
	name: 'messages',

	components: {
		DefaultLayout,
		PrimaryHeader,
	},
};
